export const SNAPSHOT_COLLECTION_TAGS = {
  SNAPSHOT_COLLECTION_TAG: "SnapshotCollection",
  SUBCOLLECTION_TAG: "Subcollection",
};
